
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(52|889|909|910)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
